/**
 * LSC1 protocol constants. See docs/LSC1-Protocol-Spec.md.
 * All multi-byte integers in the container are big-endian.
 */

/** ASCII "LSC1" */
export const MAGIC: Uint8Array = new Uint8Array([0x4c, 0x53, 0x43, 0x31]);
export const VERSION = 0x01;
export const SUITE_AES256GCM = 0x01;

export const HEADER_SIZE = 32;
export const TAG_SIZE = 16;
export const NONCE_SIZE = 12;
export const NONCE_PREFIX_SIZE = 7;

/** Header byte offsets */
export const OFF_MAGIC = 0;
export const OFF_VERSION = 4;
export const OFF_SUITE = 5;
export const OFF_CHUNK_LOG2 = 6;
export const OFF_FLAGS = 7;
export const OFF_PLAINTEXT_LENGTH = 8;
export const OFF_NONCE_PREFIX = 16;
export const OFF_RESERVED = 23;
export const RESERVED_SIZE = 9;

/** 2^22 = 4 MiB */
export const DEFAULT_CHUNK_LOG2 = 22;
export const MIN_CHUNK_LOG2 = 16;
export const MAX_CHUNK_LOG2 = 24;

export const KEY_SIZE = 32;
export const TOKEN_SIZE = 24;
export const TOKEN_B64URL_LENGTH = 32;
export const KEY_B64URL_LENGTH = 43;
export const PASSWORD_SALT_SIZE = 16;
export const PASSWORD_SALT_B64URL_LENGTH = 22;
/** nonce(12) + mk(32) + tag(16) */
export const WRAPPED_KEY_SIZE = 60;
export const WRAPPED_KEY_B64URL_LENGTH = 80;
/** Uncompressed P-256 point: 0x04 || X(32) || Y(32) */
export const P256_PUBLIC_KEY_RAW_SIZE = 65;

/** HKDF info strings */
export const INFO_MANIFEST = "LSC1/manifest";
export const INFO_FILE_PREFIX = "LSC1/file/";
export const INFO_REQUEST_WRAP = "LSC1/req/wrap";

/** AAD prefixes */
export const AAD_MANIFEST_PREFIX = "LSC1/manifest/";
export const AAD_FILEMETA_PREFIX = "LSC1/filemeta/";
export const AAD_PASSWORD_PREFIX = "LSC1/pw/";
export const AAD_REQUEST_PREFIX = "LSC1/req/";

/** Password KDF parameters */
export const PBKDF2_ITERATIONS = 600_000;
export const ARGON2_PARAMS = {
  memoryKiB: 65_536,
  iterations: 3,
  parallelism: 1,
  hashLength: 32,
} as const;

/** Manifest limits */
export const MAX_MANIFEST_CIPHERTEXT = 16 * 1024;
export const MAX_FILE_NAME_LENGTH = 255;
export const MAX_MIME_LENGTH = 128;
export const MAX_MESSAGE_LENGTH = 2000;
export const MAX_SENDER_LENGTH = 64;
export const MAX_PATH_LENGTH = 1024;

/** Identifier regexes */
export const TRANSFER_ID_RE = /^[A-Za-z0-9_-]{16}$/;
export const FILE_ID_RE = /^[A-Za-z0-9_-]{8}$/;
export const TOKEN_RE = /^[A-Za-z0-9_-]{32}$/;
export const B64URL_RE = /^[A-Za-z0-9_-]*$/;
